import axios from 'axios'
import { getToken } from '@/utils/auth'
import { getQueryString } from '@/utils/tools'
import Qs from 'qs'

export default {
  download: function(data, filename) {
    if (!data) {
      return
    }
    var blob = new Blob([data.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
    var url = window.URL.createObjectURL(blob)
    var aLink = document.createElement('a')
    aLink.style.display = 'none'
    aLink.download = filename + '.xls'
    aLink.href = url
    document.body.appendChild(aLink)
    aLink.click()
  },
  exportExcel: function(url, params, filename) {
    //兼容后台错误的用了分页
    params = Object.assign(params, {pageNum:1,pageSize:2147483647});
    let labelRouter = getQueryString('label');

    const href = window.location.href;
    let myheader = {'Authorization': getToken(labelRouter)};
    if (href.indexOf("/mis/") >= 0 || href.indexOf("/crs/") >= 0) {
      myheader['businessType']  = "gm";
    }
    if (href.indexOf("/mis/bts") >= 0 || href.indexOf("/crs/bts") >= 0){
      myheader['businessType']  = "gm";
    }

    axios.get(url, {
      params: params,
      paramsSerializer: function(params) {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: myheader,
      responseType: 'blob'
    }).then(response => {
      console.log(response)
      this.download(response, filename)
    }).catch(error => {
      console.log(error)
    })
  },
  downloadFile: function(data, filename, fileType) {
    if (!data) {
      return
    }
    var blob;
    if (fileType == "txt") {
      blob = new Blob([data.data], { type: 'text/plain;charset=utf-8' })
    } else if (fileType == "pdf") {
      blob = new Blob([data.data], { type: 'application/octet-stream;charset=utf-8' })
    } else {
      blob = new Blob([data.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
    }
    var url = window.URL.createObjectURL(blob)
    var aLink = document.createElement('a')
    aLink.style.display = 'none'
    if (fileType == "txt") {
      aLink.download = filename + '.txt'
    } else if (fileType == "csv") {
      aLink.download = filename + '.csv'
    } else if (fileType == "pdf") {
      aLink.download = filename + '.pdf'
    } else {
      aLink.download = filename + '.xls'
    }
    aLink.href = url
    document.body.appendChild(aLink)
    aLink.click()
  },
  exportFile: function(url, params, filename, fileType) {
    //兼容后台错误的用了分页
    //params = Object.assign(params, {pageNum:1,pageSize:2147483647});
    let labelRouter = getQueryString('label')
    axios.get(url, {
      params: params,
      paramsSerializer: function(params) {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: {
        'Authorization': getToken(labelRouter)
      },
      responseType: 'blob'
    }).then(response => {
      //console.log(response)
      this.downloadFile(response, filename, fileType)
    }).catch(error => {
      console.log(error)
    })
  }
}
